export default __webpack_public_path__ + "static/media/2.6289e85a.png";